export type Quote = {
  quote: string
}

export type Testimonial = {
  initials: string
  quote: string
  name: string
  role: string
}

export const QUICK_QUOTES: Quote[] = [
  {
    quote:
      'I used to spend hours every week looking for activities and putting my lessons together. Now I can choose the resources I need, adapt them to my student and plan much faster.',
  },
  {
    quote:
      'What I like most is how everything connects. Planning, grammar, vocabulary, speaking and progress tracking are finally organized within the same system.',
  },
  {
    quote:
      'I already knew how to teach Spanish. What I needed was a better system for organizing my materials and preparing lessons without rebuilding everything every week.',
  },
]

export const DETAILED_TESTIMONIALS: Testimonial[] = [
  {
    initials: 'MR',
    quote:
      'I am 46 and I have taught Spanish in a public high school for nineteen years, plus private lessons three evenings a week. Sunday afternoon was always planning time: hunting for a reading, writing a grammar worksheet, inventing conversation questions. With the lesson planner and the activity library I now build a full 60-minute lesson in about fifteen minutes, and I still adapt it to the group in front of me. I got my Sundays back and my lessons are more structured than when I was improvising.',
    name: 'Maria R., 46',
    role: 'High School Spanish Teacher · Austin, Texas',
  },
  {
    initials: 'JC',
    quote:
      'At 33 I left the classroom to teach Spanish online full time and my calendar filled up faster than my materials did. Twenty-two private students, all at different levels, and I was rewriting the same explanations over and over. The grammar toolkit gave me clear explanations and error-correction tasks I can reuse, and the scenario pack keeps my B1 students talking for the whole hour. My cancellation rate dropped because my lessons finally feel planned.',
    name: 'Jessica C., 33',
    role: 'Online Spanish Tutor · Toronto, Canada',
  },
  {
    initials: 'DK',
    quote:
      'I am 52 and I run a small language studio with four other teachers. Our biggest problem was consistency: every teacher planned differently, so a student changing schedules got a completely different experience. We adopted the lesson frameworks and the assessment rubrics across the studio and now everyone starts from the same structure. Parents notice it, and my teachers stopped asking me for materials every Monday morning.',
    name: 'Daniel K., 52',
    role: 'Language Studio Owner · Melbourne, Australia',
  },
  {
    initials: 'LP',
    quote:
      'I am 29 and in my third year of teaching Spanish, mostly adults after work. Speaking was the part I dreaded because when the conversation died I had nothing prepared to rescue it. The conversation library changed that completely: I pick a topic, a role-play and a follow-up task, and my students leave having actually spoken Spanish for forty minutes. The homework system also means I stop improvising tasks at 10pm.',
    name: 'Laura P., 29',
    role: 'Adult Spanish Instructor · Chicago, Illinois',
  },
  {
    initials: 'CS',
    quote:
      'I am 58 and after decades of teaching I did not think a resource system would help me. What convinced me was the progression and assessment module. I now have diagnostics, skill checks and trackers I can actually keep up with, so when I meet a student or a parent I show real evidence instead of impressions. The continuity tools mean every lesson picks up exactly where the last one ended.',
    name: 'Carmen S., 58',
    role: 'Private Spanish Teacher · Vancouver, Canada',
  },
]
